import React, { lazy, Suspense } from 'react';
import Loader from '../../components/Loader/Loader.lazy';

const LazyFeedbackHome = lazy(() => import('./FeedbackHome'));

const FeedbackHome = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyFeedbackHome {...props} />
  </Suspense>
);

export default FeedbackHome;
